import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompanyListItemDto } from 'src/app/models/dialog-dto/company-list-item.dto';
import { CustomerListItemDto } from 'src/app/models/dialog-dto/customer-list-item.dto';
import { DataService } from 'src/app/services/data.service';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { DialogService } from 'src/app/services/dialog.service';

export interface DialogTagScopeData {
  tagId: number;
  tagGuid: string;
  tagName: string;
}

// Edits which Clients/Customers a (Sonderfall) Tag grants access to. This is
// the only place Tag<->Client/Customer links are actually written — the
// former Client/Customer create/edit dialogs never did (the "tags" field
// they sent was silently dropped server-side).
@Component({
  selector: 'app-dialog-tag-scope',
  templateUrl: './dialog-tag-scope.component.html',
  styleUrl: './dialog-tag-scope.component.scss',
})
export class DialogTagScopeComponent implements OnInit {
  allClients: CompanyListItemDto[] = [];
  allCustomers: CustomerListItemDto[] = [];
  selectedClients: CompanyListItemDto[] = [];
  selectedCustomers: CustomerListItemDto[] = [];

  constructor(
    private dataService: DataService,
    private dialogService: DialogService,
    private dialogFormService: DialogFormService,
    private dialogRef: MatDialogRef<DialogTagScopeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogTagScopeData
  ) {}

  ngOnInit(): void {
    this.dialogService.getClientsList().subscribe((clients) => {
      this.allClients = clients;
    });
    this.dialogService.getCustomersList().subscribe((customers) => {
      this.allCustomers = customers;
    });
    this.dataService.getClientsByTag(this.data.tagId).subscribe((clients) => {
      this.selectedClients = clients;
    });
    this.dataService.getCustomersByTag(this.data.tagId).subscribe((customers) => {
      this.selectedCustomers = customers;
    });
  }

  appendClient(client: CompanyListItemDto) {
    if (!this.selectedClients.some((c) => c.id === client.id)) {
      this.selectedClients.push(client);
    }
  }

  removeClient(client: CompanyListItemDto) {
    this.selectedClients = this.selectedClients.filter((c) => c !== client);
  }

  appendCustomer(customer: CustomerListItemDto) {
    if (!this.selectedCustomers.some((c) => c.id === customer.id)) {
      this.selectedCustomers.push(customer);
    }
  }

  removeCustomer(customer: CustomerListItemDto) {
    this.selectedCustomers = this.selectedCustomers.filter((c) => c !== customer);
  }

  save() {
    this.dialogFormService
      .saveTagScope(
        this.data.tagGuid,
        this.selectedClients.map((c) => c.id),
        this.selectedCustomers.map((c) => c.id)
      )
      .subscribe((res) => {
        if (res.success) {
          this.dialogRef.close(true);
        }
      });
  }
}
